export default (props, vars) =>
  vars?.['useapplicationoffer2']?.['applicationOffer'].OFFER_LETTER_FORMS
    .ACCEPT;
